import axiosInstance from '../api.service.js';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = "Form/";

const getFormById = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'GetUploadFormById?formId=' + id, constants.REQUIRE_INTERCEPTORS);

const getAllForms = async () => await axiosInstance.get(ENDPOINTORIGIN + 'GetAllForms', constants.REQUIRE_INTERCEPTORS);

const saveUploadForm = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'SaveUploadForm', model, { ...constants.REQUIRE_INTERCEPTORS, fileHandler: true });

const deleteForm = async (formId) => await axiosInstance.get(ENDPOINTORIGIN + 'DeleteForm?formId=' + formId, constants.REQUIRE_INTERCEPTORS);

export {
    getFormById,
    getAllForms,
    saveUploadForm,
    deleteForm
}